var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1709596857194,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1467,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M796.059711 128.365195a482.807533 482.807533 0 0 1 34.969965 28.562639 17.254917 17.254917 0 1 0 23.064073-25.663813c-11.963409-10.755565-24.571002-21.050999-37.47768-30.621726a17.256067 17.256067 0 1 0-20.556358 27.7229z",
    fill: "#71533e",
    "p-id": 1468
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M942.427421 234.839536a17.254917 17.254917 0 1 0-28.988261 18.715833 475.626037 475.626037 0 0 1 76.013661 258.559181c0 263.229511-214.145024 477.386038-477.386038 477.386038s-477.386038-214.156527-477.386038-477.386038 214.145024-477.386038 477.386038-477.386039a475.683553 475.683553 0 0 1 166.659492 29.908523 17.254917 17.254917 0 0 0 12.055436-32.335714 511.964892 511.964892 0 1 0 251.64571 202.538216z",
    fill: "#71533e",
    "p-id": 1469
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M482.917477 318.882485c0 21.47662 8.052295 50.614423 16.104589 59.817046a64.510383 64.510383 0 0 1 16.104589 42.562129c0 31.449962-21.465117 57.51639-52.915079 57.51639-28.183031 0-47.16344-21.856228-60.967373-41.411801-24.709041-37.33964-63.463585-60.967374-111.581797-60.967374a138.039336 138.039336 0 1 0 113.192256 217.089863 132.885868 132.885868 0 0 0 6.441835-13.539358 56.95273 56.95273 0 0 1 109.281142 22.488909c0 13.803934-5.970201 25.640807-13.067724 36.281339-3.036865 4.601311-3.036865 5.751639-6.821444 12.204978a138.039336 138.039336 0 1 0 129.446388-83.525302h-11.79086c-31.449962 0-56.366062-24.340936-56.366063-55.790899s26.066428-55.790898 57.51639-55.790898a110.845587 110.845587 0 0 1 14.034 0.747713 138.039336 138.039336 0 1 0-148.610849-137.682735z",
    fill: "#71533e",
    "p-id": 1470
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/XRP.355914ff856e1e5d06a348a2ecedea95.svg";
export { ForwardRef as ReactComponent };